import React from  'react'
import { Dialog } from 'evergreen-ui'
import Map from '../../../../../Components/Map'

const AttendanceLocationDialog = ({
  location, dateTime, visible, close = () => {}
}) => (
    <Dialog
      isShown={visible}
      title="Local de registro"
      intent="danger"
      onCloseComplete={() => close()}
      hasFooter={false}
      width={750}
    >
      {(location && (
        <Map
          initialLocation={{ latitude: location.latitude, longitude: location.longitude }}
          finalLocation={{ latitude: location.latitude, longitude: location.longitude }}
          createdAt={dateTime.date}
          terminatedAt={dateTime.date}
        />
      )) || null}
    </Dialog>
  )

  export default AttendanceLocationDialog